import React from 'react';
import bn from 'utils/bemnames';
import {
  Navbar,
  // NavbarToggler,
  Nav,
  NavItem,
  NavLink,
  Popover,
  PopoverBody,
  ListGroup,
  ListGroupItem,
  Button,
} from 'reactstrap';

import {
  //MdNotificationsActive,
  // MdNotificationsNone,
  // MdInsertChart,
  // MdPersonPin,
  // MdMessage,
  // MdSettingsApplications,
  // MdHelp,
  // MdClearAll,
  MdMenu,
  MdExitToApp,
} from 'react-icons/md';
import { Link } from 'react-router-dom';
//import userImage from 'assets/img/users/100_4.jpg';
import profileIcon from 'assets/img/profile-icon.png';
import profileeditIcon from 'assets/img/profile-edit-icon.png';
import changePassIcon from 'assets/img/change-pass-icon.png';
//import Avatar from 'components/Avatar';
import { UserCard } from 'components/Card';
//import Notifications from 'components/Notifications';
//import SearchInput from 'components/SearchInput';

//import withBadge from 'hocs/withBadge';

// import { notificationsData } from 'demos/header';
// import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { logoutUser,getProfile} from 'actions/authentication';

import AppConstants from 'AppConstants';
import placeholderimg from '../../assets/img/placeholder.png';
const bem = bn.create('header');

// const MdNotificationsActiveWithBadge = withBadge({
//   size: 'md',
//   color: 'primary',
//   style: {
//     top: -10,
//     right: -10,
//     display: 'inline-flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//   },
//   children: <small>5</small>,
// })(MdNotificationsActive);

class Header extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      _id:this.props.auth.user._id,
      firstname:'',
      username:'',
      lastname:'',
      email:'',
      user_type:'',
      profile_img:'',
      isOpenNotificationPopover: false,
      isNotificationConfirmed: false,
      isOpenUserCardPopover: false,
    }
  }
  componentDidMount() { 
    //const that = this;       
   // this.props.getProfile(this.state._id)
   this.props.getProfile(this.props.auth.user._id)
    //AppConstants.API
    /* axios.get('/users/profile/'+this.props.auth.user._id)
    .then(res => {      
      if(res.data.Status == "Success"){
        this.setState({
          username:res.data.data.username,
          email:res.data.data.email,
          profile_img:res.data.data.profile_img,
        });
      }
      else{
      }
    }) */
   // console.log(this.props.auth.user._id);
    // fetch(AppConstants.API+'/users/profile/'+this.props.auth.user._id)
    // .then(function(res) {
    //   //if(res.status == 200){
    //     //console.log("user", res);
    //     if(res.status === 200){
    //     return res.json();
    //   }
    // })
    // .then(function(data) {
    //   if(data.Status === "Success"){
    //    // console.log("user_type:", data.data);
    //     that.setState({
    //       firstname:data.data.firstname,
    //       lastname:data.data.lastname,
    //       //username:data.data.username,
    //       user_type:data.data.user_type,
    //       email:data.data.email,
    //       profile_img:data.data.profile_image,
    //     });
    //   }else
    //   {
    //   }
    // });
  }

  toggleNotificationPopover = () => {
    this.setState({
      isOpenNotificationPopover: !this.state.isOpenNotificationPopover,
    });

    if (!this.state.isNotificationConfirmed) {
      this.setState({ isNotificationConfirmed: true });
    }
  };

  toggleUserCardPopover = () => {
    this.setState({
      isOpenUserCardPopover: !this.state.isOpenUserCardPopover,
    });
  };

  handleSidebarControlButton = event => {
    event.preventDefault();
    event.stopPropagation();

    document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
  };
  
  onLogout(e) {
    e.preventDefault();
    this.props.logoutUser(this.props.history);
  }

  getViewProfile = event => {
    this.toggleUserCardPopover();
  }

  getEditProfile = event => {
    this.toggleUserCardPopover();
  }

  getChangePassword = event => {
    this.toggleUserCardPopover();
  }

  getUploadProfilePic = event => {
    this.toggleUserCardPopover();
  }

  /* getUploadProfilePic = event => {
    this.toggleUserCardPopover();
  } */
  

  render() {
    const {user} = this.props.auth;
    var username = `${user.firstname} ${user.lastname}`;
   // console.log("this.state.profile_img",this.state.profile_img);
	let image;
    if (user.profile_image == '' && user.profile_image == undefined) {
      image = placeholderimg;
    }
    else{
      image = user.profile_image;
    }

let admin_type;
    if (this.state.user_type == 'admin') {
      admin_type = "Admin";
    }
    else{
      admin_type = "Super Admin";
    }
    return (
      <Navbar light expand className={bem.b('bg-white')}>
        <Nav navbar className="mr-2">
          <Button outline onClick={this.handleSidebarControlButton}>
            {/* <MdClearAll size={25} /> */}
            <MdMenu size={25} />
          </Button>
        </Nav>
      

        <Nav navbar className={bem.e('nav-right')}>  
    <NavItem className="wel-text">Welcome,<span>{username}<em>{admin_type}</em></span></NavItem>      

          <NavItem>
            <NavLink id="Popover2">
              {/* <Avatar
                onClick={this.toggleUserCardPopover}
                className="can-click"
              /> */}
              <img src={image} onClick={this.toggleUserCardPopover}
                className="can-click" style={{width: 40, height: 40,borderRadius:50}}/>
            </NavLink>
            <Popover
              placement="bottom-end"
              isOpen={this.state.isOpenUserCardPopover} 
              toggle={this.toggleUserCardPopover}
              target="Popover2"
              className="p-0 border-0"
              style={{ minWidth: 250 }}>
              <PopoverBody className="p-0 border-light">
                <UserCard
                  //title={this.state.firstname +" "+ this.state.lastname}
                  title={username}
                  subtitle={this.state.email}
                  className="border-light">
                  <ListGroup flush>
                    <ListGroupItem tag="li" action className="border-light">
                      <figure> <img src={profileIcon} /></figure>
                      <Link to={`/viewadminprofile`} onClick={this.getViewProfile.bind(this)} style={{color:"#212529"}}>View Profile</Link>
                    </ListGroupItem>
                    <ListGroupItem tag="li" action className="border-light">
                    <figure> <img src={profileeditIcon} /></figure>
                      <Link to={`/editadminprofile`} onClick={this.getEditProfile.bind(this)} style={{color:"#212529"}}>Edit Profile</Link>
                    </ListGroupItem>
                    <ListGroupItem tag="li" action className="border-light">
                    <figure> <img src={changePassIcon} /></figure>
                      <Link to={`/changeadminpassword`} onClick={this.getChangePassword.bind(this)} style={{color:"#212529"}}>Change Password </Link>
                    </ListGroupItem>
                    {/* <ListGroupItem tag="button" action className="border-light">
                      <MdPersonPin />
                      <Link to={`/uploadnigpnaic`} onClick={this.getUploadProfilePic.bind(this)} style={{color:"#212529"}}>Upload Nigp/Naic </Link>
                    </ListGroupItem> */}
                    <ListGroupItem tag="li" action className="border-light">
                      <MdExitToApp /> <a href="#" onClick={this.onLogout.bind(this)}> Logout </a>
                    </ListGroupItem>
                  </ListGroup>
                </UserCard>
              </PopoverBody>
            </Popover>
          </NavItem>
        </Nav>
      </Navbar>
    );
  }
}
// Header.propTypes = {
//   logoutUser: PropTypes.func.isRequired,
//   auth: PropTypes.object.isRequired
// }

const mapStateToProps = (state) => ({
  auth: state.auth
})
//export default Header;
export default connect(mapStateToProps, { logoutUser,getProfile })(withRouter(Header));
